import React, { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { Icon } from "semantic-ui-react";
import usePhoto from "@common/components/hooks/usePhoto";
import { loadFile } from "@common/components/helpers/fileReader";
import LoadingAction from "@common/redux/actions/LoadingAction";

const PhotoUploader = () => {
  const { setPhotoState } = usePhoto();

  const onDrop = useCallback(async (acceptedFiles) => {
    if (acceptedFiles.length === 0) return;

    setPhotoState({ photo: null });

    LoadingAction.set(true)
      .then(() => {
        // Process only the first file (since we only accept one)
        const file = acceptedFiles[0];
        loadFile(file).then((encodedResult) => {
          setPhotoState({
            photo: encodedResult.encoded,
            updatePhoto: true,
          });
        });
      })
      .catch((error) => {
        console.error("Error processing files:", error);
      })
      .finally(() => {
        LoadingAction.set(false);
      });
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      "image/*": [".jpeg", ".jpg"],
    },
    multiple: false, // Only accept single file
    maxFiles: 1,
  });

  return (
    <div {...getRootProps()}>
      <input {...getInputProps()} />
      {isDragActive ? (
        <p>Drop the files here ...</p>
      ) : (
        <div className="text-center">
          <Icon className="m-a" name="upload" />
          <p className="mt-0_5 text-12px">Upload File</p>
        </div>
      )}
    </div>
  );
};

export default PhotoUploader;
